import { Button, Form, InlineLoading } from '@carbon/react';
import styled from '@emotion/styled';

export const ContentForm = styled(Form)`
  padding: 0;

  .cds--modal-footer {
    background: ${ props => props.theme.colors.white };
    gap: 1rem;
    height: auto;
    padding: 1rem;
  }

  .wrapper {
    padding: 1rem;
  }

  .cds--form-item {
    margin-bottom: 0.875rem !important;
  }

  .cds--text-input,
  .cds--dropdown,
  .cds--combo-box {
    border: 1px solid ${ props => props.theme.products.colors.border };
    border-radius: 6px;
  }

  .section-heading {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 1rem 0 0.75rem;

    p {
      font-size: 1rem;
      font-weight: 600;
    }

    button {
      color: ${ props => props.theme.colors.blue };
      min-height: auto;
      padding: 0.25rem;
    }
  }
`;

export const PrimaryButton = styled(Button)`
  align-items: center;
  background: ${ props => props.theme.colors.red } !important;
  border: 1px solid ${ props => props.theme.colors.red } !important;
  color: ${ props => props.theme.colors.white } !important;
  display: flex;
  flex: 1 1 0;
  font-size: 1.25rem;
  justify-content: center;
  max-width: none !important;
  min-height: 3.75rem;
  padding: 0 !important;
  text-align: center;
`;

export const SecondaryButton = styled(Button)`
  align-items: center;
  background: ${ props => props.theme.colors.white } !important;
  border: 1px solid ${ props => props.theme.colors.red } !important;
  color: ${ props => props.theme.colors.red } !important;
  display: flex;
  flex: 1 1 0;
  font-size: 1.25rem;
  justify-content: center;
  max-width: none !important;
  min-height: 3.75rem;
  padding: 0 !important;
  text-align: center;

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background: #fff1f1 !important;
  }
`;

export const SubmitLoading = styled(InlineLoading)`
  left: 20px;
  position: absolute;
  width: auto;

  svg {
    height: 16px;
    margin-right: 12px;
  }
`;

export const Notice = styled.div`
  background: ${ props => props.variant === 'storage' ? '#fff8e1' : '#edf8f5' };
  border: 1px solid ${ props => props.variant === 'storage' ? '#ead99a' : '#8bc5b7' };
  border-radius: 6px;
  color: ${ props => props.theme.colors.darkGray };
  margin-bottom: 1rem;
  padding: 0.75rem;

  strong {
    display: block;
    margin-bottom: 0.25rem;
  }
`;
